import { useEffect, useState, useContext } from 'react';
import DrawerIcon from '../assets/svg/header/drawericon.svg';
import ShoppingCart from '../assets/svg/shopping_cart.svg';
import CompanyLogo from '../assets/header_logo.png';
import Badge from '@mui/material/Badge';
import { AuthContext } from '../pages/RootPage';

import { useLocation, useNavigate } from 'react-router-dom';
import RightArrow from '../assets/svg/right.svg'

import '../styles/HeaderProductList.css'
function HeaderProductlist({ parent, heading }) {
    const navigate = useNavigate()
    const { toggleDrawer } = useContext(AuthContext);
    const location = useLocation()
    const [badgeCount, setbadgeCount] = useState(0);
    const [logo, setlogo] = useState(CompanyLogo);

    useEffect(() => {
        getCompanyInfo();
        getCartCount();
        window.addEventListener('productQtyChange', getCartCount);
        return () => {
            window.removeEventListener('productQtyChange', getCartCount);
        };
    }, []);

    const getCompanyInfo = () => {
        const value = localStorage.getItem('companyInfo');
        if (value) {
            let companyInfo = JSON.parse(value);
            const Logo = (companyInfo.logo && companyInfo.logo !== "") ? companyInfo.logo : CompanyLogo;
            setlogo(Logo);
        }
    };

    const getCartCount = () => {
        const cart = localStorage.getItem('cartItems');
        if (!cart) {
            setbadgeCount(0);
        } else {
            const cartItems = JSON.parse(cart);
            setbadgeCount(cartItems?.customerCartItems?.length || 0);
        }
    };

    return (
        <div className='containerHeaderProduct'>
            <div className='header-mobile-bar' style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between', paddingInline: '12px' }}>
                <div className='drawer-icon-product' style={{ margin: 0, cursor: 'pointer' }}>
                    <img src={DrawerIcon} style={{ width: 20, height: 20 }} onClick={() => toggleDrawer()} alt="Menu" />
                </div>

                <div
                    style={{
                        display: "flex",
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingInline: "8px",
                    }}
                    onClick={() => navigate("/")}
                >
                    <img src={logo || CompanyLogo} height="auto" width={140} alt="Store Logo" style={{ cursor: "pointer", maxWidth: "100%", maxHeight: "38px", objectFit: "contain" }} />
                </div>

                <div
                    style={{ cursor: "pointer", padding: "4px 6px", display: "flex", alignItems: "center" }}
                    onClick={() => navigate("/Cart")}
                    title="Cart"
                >
                    <Badge badgeContent={badgeCount} color="warning">
                        <img src={ShoppingCart} style={{ width: 24, height: 24 }} alt="Cart" />
                    </Badge>
                </div>
            </div>

            <div className='routeWrapper' style={{ marginTop: '4px', paddingInline: '15px' }}>
                <p className='route-names' onClick={() => navigate('/')}>Home</p>
                <img src={RightArrow} alt=">" />
                <p className='route-names' onClick={() => navigate('/Categories')}>Categories</p>
                <img src={RightArrow} alt=">" />
                {
                    location?.state?.heading &&
                    <p style={{ fontFamily: 'Poppins-Regular', fontSize: '14px', flexWrap: 'nowrap', margin: 0 }}>{location?.state?.heading}</p>
                }
            </div>
        </div>
    )
}

export default HeaderProductlist